module.exports = __webpack_public_path__ + "img/img24.f2f86e1d.jpg";